import React from 'react';

import { Platform, View } from 'react-native';

import { useTranslation } from 'react-i18next';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

export default function EpgLoadingRow() {
    const { t } = useTranslation();

    return (
        <View style={styles.root}>
            <Text
                numberOfLines={1}
                ellipsizeMode="tail"
                category={ETextCategory.body2}
                color={ETextColor.neutral}
                style={Platform.OS === 'web' && styles.webStickyText}
            >
                {t(LANGUAGE_KEYS.EPG.EPG_LOADING)}
            </Text>
        </View>
    );
}
